import { ApiCalls } from "./libs/api_calls";
import { CookieBytes } from "./libs/cookieManager";
import { NotificationLib } from './libs/notification/NotificationLib.js';


const cookieManager = new CookieBytes();
const Notification = new NotificationLib();

var backend_url = undefined;
var api = undefined;
var noSpecialCharsRegex = /[^\w\s]/; 
var emailSpecialCharsRegex = /[^a-zA-Z0-9 ._+@]/g;

const commonHeaders = {
    "Content-Type": "application/json"
};

function getParamVaue(key) {
	let urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(key);
}

function getBackendUrl() {
	let backend_url;
	if (BACKEND_URL) {
		backend_url = BACKEND_URL;
	} else {
		backend_url = false;
	}
	console.log("BACKEND URL:", backend_url);
	return backend_url;
}


function getApiObject(url) {
	return new ApiCalls(url);
}

function getAuthHeaders() {
	let authHeaders = {
		"FTRK-USER-ACCOUNT" : cookieManager.get("account"),
		"FTRK-USER-ID" : cookieManager.get("username"),
		"FTRK-USER-API-KEY" : cookieManager.get("token"),
		"FTRK-SESSION-TYPE" : cookieManager.get("session_type")
	}
	return Object.assign({}, commonHeaders, authHeaders);
}

function getUserDetailsFromCookies() {
	console.log("Fetching user information from cookies.");
	return {
		"account" : cookieManager.get("account"),
		"username" : cookieManager.get("username")
	}
}

function startNewSession(response) {
	if (response.status) {
		cookieManager.set("username", response.data.uid, 1);
		cookieManager.set("token", response.data.apikey, 1);
		cookieManager.set("session_type", response.data.owner, 1);
		console.log("Shopping session started.");
	} else {
		console.error("Unable to start a session.");
	}
}

function getMediaUrlPrefix() {
	return "http://localhost:8081"
}

function verifySession(response) {
	if (response.status) {
		Notification.notify("success", "Session Validated. Logging in to dashboard.")

		console.log("Valid Session, continuing to dashboard.");
		if (window.location.pathname == "/") {
			window.location = "/dashboard.html";
		}
		return;
	} else {
		console.log("Invalid Session, login required.");
		window.location = "/index.html";
		// createNewSession();
		return;
	}
}

function notifyFailure(e) {
	console.log(e);
	Notification.notify("error", "Failed connecting to backend.");
}

function initSession(redirect_to_root) {
	Notification.notify("success", "Initiating session.")
	redirect_to_root = true
	if (redirect_to_root === false) {
		redirect_to_root = false
	}
	api = getApiObject(getBackendUrl())
	let username = cookieManager.get("username");
	let token = cookieManager.get("token");
	let session_type = cookieManager.get("session_type");
	session_type = session_type || "user";
	console.log("Starting "+session_type+" session..")
	
	if (!username || !token || !session_type) {
		console.log("No session information in cookies. Login required.");
		if (window.location.pathname == "/index.html" || window.location.pathname == "/") {
			return false;
		} 
		if (redirect_to_root){
			console.log("Redirecting to /.")
			window.location = "/"
		}
	}

	Notification.notify("success", "Validating session.")
	api.postData("/"+session_type+"/verify-token", commonHeaders, [], {
		"username": username,
		"token": token
	}, verifySession, notifyFailure);
	console.log("Done.")
	
}

function logout() {
	cookieManager.del("account");
	cookieManager.del("username");
	cookieManager.del("name");
	cookieManager.del("session-login-timestamp");
	cookieManager.del("token");
	cookieManager.del("session_type");

    window.location.href = "/";
}

function loadLogo() {
	document.getElementById("mainLogo").innerHTML = "GalacticTripper ERP DASHBOARD";
}

function loadVersion() {
	let version = "v" + APP_VERSION + " "+ BUILD_DATE + " " + COMMIT_HASH;
	document.querySelector("#version_info>span").innerHTML = version;
}

function updateSessionInfo() {
	document.getElementById("session_login_timestamp").innerHTML = cookieManager.get("session-login-timestamp");
	document.getElementById("session_user_name").innerHTML = cookieManager.get("name");
	document.getElementById("session_user_id").innerHTML = cookieManager.get("username");
}

function hasSpecialChars(str, type) {
	console.log(str);
	let match_test = false;
	// Matches any non-word character (except underscore) or non-whitespace
	if (type == "name") {
		match_test = noSpecialCharsRegex.test(str)
		noSpecialCharsRegex.lastIndex = 0;
	} else if (type == "email") {
		match_test = emailSpecialCharsRegex.test(str);
		emailSpecialCharsRegex.lastIndex = 0;
	}

	return match_test;
}

function highlightBorder(ele, color) {
	ele.style.border = "5px solid "+color;
}

function makeBorderRed(ele) {
	highlightBorder(ele, "red");
}

function removeBorder(ele) {
	ele.style.border = "none";
}

export {
	cookieManager, 
	getAuthHeaders, 
	getBackendUrl, 
	getApiObject, 
	commonHeaders, 
	initSession,
	logout,
	loadLogo,
	getMediaUrlPrefix,
	getParamVaue,
	getUserDetailsFromCookies,
	loadVersion,
	hasSpecialChars,
	makeBorderRed,
	removeBorder,
	updateSessionInfo
}
